<template>
    <div class="navbar navbar-expand-md navbar-dark" v-show="currentRoute.path !== '/login'">
        <div class="navbar-brand padding-zero">
            <a href="/" >
                <div class="logo-font-style">
                  UMS System
                  <span class="logo-profile-font-style"> [ demo ]</span>
                </div>
            </a>
        </div>

        <div class="d-md-none">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-mobile">
                <i class="icon-tree5"></i>
            </button>
            <button class="navbar-toggler sidebar-mobile-main-toggle" type="button">
                <i class="icon-paragraph-justify3"></i>
            </button>
        </div>

        <div class="collapse navbar-collapse" id="navbar-mobile">
            <ul class="navbar-nav" @click="navInit">
                <li class="nav-item">
                    <a href="#" class="navbar-nav-link sidebar-control sidebar-main-toggle hidden-xs">
                        <i class="icon-paragraph-justify3"></i>
                    </a>
                </li>
            </ul>
            <ul class="navbar-nav ml-md-auto">
                <li class="nav-item dropdown dropdown-user">
                    <a href="#" class="navbar-nav-link d-flex align-items-center dropdown-toggle" data-toggle="dropdown">
                        <img src="/assets/global_assets/images/placeholders/placeholder.jpg" class="rounded-circle mr-2" height="34" alt="">
                        <span>{{user?user.data.usrId:''}}</span>
                    </a>

                    <div class="dropdown-menu dropdown-menu-right">
<!--                        <a href="#" class="dropdown-item"><i class="icon-user-plus"></i> My profile</a>-->
<!--                        <a href="#" class="dropdown-item"><i class="icon-coins"></i> My balance</a>-->
<!--                        <a href="#" class="dropdown-item"><i class="icon-comment-discussion"></i> Messages <span class="badge badge-pill bg-blue ml-auto">58</span></a>-->
<!--                        <div class="dropdown-divider"></div>-->
<!--                        <a href="#" class="dropdown-item"><i class="icon-cog5"></i> Account settings</a>-->
                        <a class="dropdown-item" href="javascript:void(0)" @click="logout"><i class="icon-switch2"></i> Logout</a>
                    </div>
                </li>
                    <!--   if language support -->
<!--                <li class="nav-item dropdown dropdown-user">-->
<!--                    <a href="#" class="navbar-nav-link d-flex align-items-center dropdown-toggle" data-toggle="dropdown">-->
<!--                        <i class="rounded-circle mr-2 icon-earth"  height="34"></i>-->
<!--                        <span>{{currentLocale | upperCase}}</span>-->
<!--                    </a>-->

<!--                    <div class="dropdown-menu dropdown-menu-right">-->
<!--                        <a href="javascript:void(0)" class="dropdown-item" @click="changeLocale('in')"><i class="icon-mi-keyboard-arrow-right"></i> IN</a>-->
<!--                        <a href="javascript:void(0)" class="dropdown-item" @click="changeLocale('en')"><i class="icon-mi-keyboard-arrow-right"></i> EN</a>-->
<!--                        <a href="javascript:void(0)" class="dropdown-item" @click="changeLocale('ko')"><i class="icon-mi-keyboard-arrow-right"></i> KO</a>-->
<!--                    </div>-->
<!--                </li>-->
            </ul>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import i18n from '@/config/i18n'
    import api from '@/api/support'
    import router from "@/config/routes";
    import constant from "@/config/const/const";
    export default {
        name: "layout-header",
        data() {
            return {
                email: '',
                lang:'',
                profileName: '?'
            }
        },
        mounted() {
          this.initHeader()
        },
        computed: {
          user: function() {
              return this.getUser()
          }
        },
        methods: {
            ...mapGetters({
               getUser: 'auth/getUser'
            }),
            changeLocale: function(value) {
                i18n.locale = value
            },
            initHeader: function() {
                api.getProfile().then((result) => {
                  if(result && result.data.code === 1000) {
                    this.profileName = result.data.content
                  }
                })
            },
            navInit:function() {
                $('.nav-link.active').closest('.nav-group-sub').slideDown(250)
                $('.nav-link.active').closest('.nav-item-submenu').addClass('nav-item-open')
            },
            logout:function() {
                window.localStorage.removeItem('check-user')
                window.location.href = '/login'
            }
        },
    }
</script>

<style scoped>
    .logo-font-style {
        padding: 5px;
        font-size: 24px;
        color: white;
        font-style: oblique;
        font-weight: 900;
        font-family: unset;
    }
    .padding-zero {
        padding: 0;
    }
    .logo-profile-font-style {
      padding: 5px;
      font-size: 18px;
      color: white;
      font-style: oblique;
      font-weight: 400;
      font-family: unset;
    }
</style>
